import { DataFieldType } from "../../../shared/types";
import { DataFieldRuleValidator } from "./types";

export const dataFieldContainsOne: DataFieldRuleValidator = {
	validate({ isImplicitlyRequired }, dataFieldType, dataFieldValue, ruleValue): boolean {
		if (dataFieldValue === null || dataFieldValue === undefined) {
			return !isImplicitlyRequired;
		}
		switch (dataFieldType) {
			case DataFieldType.CHECKBOX_GROUP:
			case DataFieldType.MULTI_SELECT_FIELD: {
				return (ruleValue as number[]).some((v) => (dataFieldValue as number[]).includes(v));
			}
			case DataFieldType.RADIO:
			case DataFieldType.CHECKBOX:
			case DataFieldType.SELECT_FIELD:
				return (ruleValue as number[]).includes(Number(dataFieldValue));
			case DataFieldType.URL:
			case DataFieldType.EMAIL:
			case DataFieldType.LONG_TEXT:
			case DataFieldType.TEXT:
			case DataFieldType.CRYPT:
			case DataFieldType.PHONE:
				return (ruleValue as string[]).some((v) =>
					(dataFieldValue ? (dataFieldValue as string).toLowerCase() : "").includes(v),
				);
			default:
				return (ruleValue as string[]).some((v) => (dataFieldValue as string) === v);
		}
	},
	getErrorMessage({ t }, dataField, _, ruleValue): string {
		const key = "Field must contain one of the following values: {{value}}";
		const values = { value: "" };

		switch (dataField.type) {
			case DataFieldType.RADIO:
			case DataFieldType.SELECT_FIELD:
			case DataFieldType.CHECKBOX_GROUP:
			case DataFieldType.MULTI_SELECT_FIELD: {
				const value = ruleValue as number[];
				values.value = dataField.options
					.filter((x) => value.includes(x.id))
					.map((x) => x.value)
					.join(", ");
				break;
			}
			default:
				values.value = (ruleValue as string[]).join(", ");
		}

		return t(key, values);
	},
};
